import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';

import { SkyTileDashboardColumnComponent } from '../tile-dashboard-column';
import { SkyTileDashboardConfig } from '../tile-dashboard-config';
import { SkyTileDashboardService } from './tile-dashboard.service';


export class SkyTileDashboardComponent implements AfterViewInit, OnDestroy {
  
  public set config(value: SkyTileDashboardConfig) {
    if (value && !this.configSet) {
      this._config = value;
      this.configSet = true;
      this.checkReady();
    }
  }

  public get config(): SkyTileDashboardConfig {
    return this._config;
  }

  
  public configChange = new EventEmitter<SkyTileDashboardConfig>();

  
  public columns: QueryList<SkyTileDashboardColumnComponent>;

  
  public singleColumn: SkyTileDashboardColumnComponent;

  private _config: SkyTileDashboardConfig;

  private configSet = false;

  private viewReady = false;

  constructor(
    // HACK: This is public so it can be accessed via a unit test due to breaking changes
    // in RC5. https://github.com/angular/angular/issues/10854
    public dashboardService: SkyTileDashboardService
  ) {
    dashboardService.configChange.subscribe((config: SkyTileDashboardConfig) => {
      this.configChange.emit(config);
    });
  }

  public ngAfterViewInit() {
    this.viewReady = true;
    this.checkReady();
  }

  public ngOnDestroy() {
    this.dashboardService.destroy();
  }

  private checkReady() {
    if (this.viewReady && this.config) {
      setTimeout(() => {
        this.dashboardService.init(this.config, this.columns, this.singleColumn);
      }, 0);
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-tile-dashboard',
  styles: [`:host {
  display: flex;
  padding: 0 10px;
}

.sky-tile-dashboard-layout-multi {
  display: block;
}

.sky-tile-dashboard-layout-single {
  display: none;
}

@media (max-width: 991px) {
  :host {
    display: block;
    padding: 0;
  }
  .sky-tile-dashboard-layout-multi {
    display: none;
  }
  .sky-tile-dashboard-layout-single {
    display: block;
  }
  :host /deep/ .sky-tile-dashboard-column {
    padding: 0;
  }
}

@media (max-width: 767px) {
  :host /deep/ .sky-tile {
    margin-bottom: 0 !important;
  }
}
`],
  template: `<sky-tile-dashboard-column
  *ngFor="let column of config?.layout?.multiColumn"
  class="sky-tile-dashboard-layout-multi"
  [ngStyle]="{
    'flex-basis': (100 / config?.layout?.multiColumn.length) + '%'
  }"
>
</sky-tile-dashboard-column>
<sky-tile-dashboard-column class="sky-tile-dashboard-layout-single" #singleColumn>
</sky-tile-dashboard-column>
<ng-content></ng-content>
`,
  providers: [SkyTileDashboardService]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyTileDashboardService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'config': [{ type: Input },],
'configChange': [{ type: Output },],
'columns': [{ type: ViewChildren, args: [SkyTileDashboardColumnComponent, ] },],
'singleColumn': [{ type: ViewChild, args: ['singleColumn', {read: SkyTileDashboardColumnComponent}, ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
